import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HoverScrollText = ({ children, className, title }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [scrollDistance, setScrollDistance] = useState(0);
  const titleText = title ?? (typeof children === 'string' ? children : undefined);

  const handleMouseEnter = () => {
    const containerElement = containerRef.current;
    const textElement = textRef.current;
    if (!containerElement || !textElement) return;

    setScrollDistance(Math.max(textElement.scrollWidth - containerElement.clientWidth, 0));
  };

  return (
    <Container
      ref={containerRef}
      className={className}
      title={titleText}
      $scrollDistance={scrollDistance}
      onMouseEnter={handleMouseEnter}
    >
      <Text ref={textRef}>{children}</Text>
    </Container>
  );
};

const Text = styled.span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
`;

const Container = styled.span`
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  --hover-scroll-distance: ${({ $scrollDistance }) => $scrollDistance}px;

  ${({ $scrollDistance }) =>
    $scrollDistance > 0
      ? `
  &:hover ${Text} {
    animation: hover-scroll-text-marquee 3s linear infinite;
    max-width: none;
    overflow: visible;
    text-overflow: clip;
  }
`
      : ''}

  @media (prefers-reduced-motion: reduce) {
    &:hover ${Text} {
      animation: none;
    }
  }

  @keyframes hover-scroll-text-marquee {
    0%,
    12% {
      transform: translateX(0);
    }
    88%,
    100% {
      transform: translateX(calc(var(--hover-scroll-distance) * -1));
    }
  }
`;

HoverScrollText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default HoverScrollText;
